

export default function QuoteBlock({title, blurb}) {

    return (
        <div className="mb-4 space-y-2">
            <blockquote>
                <p>
                    {title}
                </p>
            </blockquote>
            <p>
                {blurb}
            </p>
        </div>
    )
}